import { Group } from '@mantine-8/core';
import { useMemo, type FC } from 'react';
import { Parameters } from '../../../../../features/parameters';
import useDashboardContext from '../../../../../providers/Dashboard/useDashboardContext';
import useDashboardTileStatusContext from '../../../../../providers/Dashboard/useDashboardTileStatusContext';

const EmbedDashboardParameters: FC = () => {
    const parameterValues = useDashboardContext((c) => c.parameterValues);
    const handleParameterChange = useDashboardContext((c) => c.setParameter);
    const clearAllParameters = useDashboardContext((c) => c.clearAllParameters);
    const parameterDefinitions = useDashboardContext(
        (c) => c.parameterDefinitions,
    );
    const parameterReferences = useDashboardContext(
        (c) => c.dashboardParameterReferences,
    );
    const areAllChartsLoaded = useDashboardTileStatusContext(
        (c) => c.areAllChartsLoaded,
    );
    const missingRequiredParameters = useDashboardContext(
        (c) => c.missingRequiredParameters,
    );

    const referencedParameters = useMemo(() => {
        return Object.fromEntries(
            Object.entries(parameterDefinitions).filter(([key]) =>
                parameterReferences.has(key),
            ),
        );
    }, [parameterDefinitions, parameterReferences]);

    return (
        <Group gap="xs" wrap="wrap" style={{ flexShrink: 0 }}>
            <Parameters
                isEditMode={false}
                parameterValues={parameterValues}
                onParameterChange={handleParameterChange}
                onClearAll={clearAllParameters}
                parameters={referencedParameters}
                isLoading={!areAllChartsLoaded}
                missingRequiredParameters={missingRequiredParameters}
            />
        </Group>
    );
};

export default EmbedDashboardParameters;
